// Best-effort, on-demand screenshot of the visible child Journey only.
// The existing /api/ask_ai context.screenshot transport accepts this data URL.
// Do not capture the full browser (account chrome or Swan conversation), and
// never treat a screenshot as evidence of a physical experiment or completion.
import html2canvas from "html2canvas";

export async function captureJourneyStageScreenshot() {
  if (typeof document === "undefined") return null;
  const stage = document.getElementById("swan-journey-stage");
  if (!stage) return null;
  try {
    const width = stage.clientWidth;
    const height = stage.clientHeight;
    if (!width || !height) return null;
    const canvas = await html2canvas(stage, {
      useCORS: true,
      allowTaint: false,
      logging: false,
      backgroundColor: "#ffffff",
      // Keep bounded for reliable request sizes and predictable AI latency.
      scale: Math.min(1, 1150 / Math.max(width, height)),
      width,
      height,
    });
    const dataUrl = canvas.toDataURL("image/jpeg", 0.65);
    return dataUrl.length <= 1900000 ? dataUrl : null;
  } catch (_error) {
    // Off-origin images, embedded PWOs, and some browsers cannot be captured.
    // The live structured Journey state is sufficient for text-only coaching.
    return null;
  }
}
